<template>
  <div class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail':bg}">
    </div>
      <section
        class="size_detail zero_right margin_top_detail padding_bottom_detail has-background-white">
        <div class="columns is-marginless detail_content max-height">
          <a @click="$parent.show = false"
            class="detail_icon_close_right topVert">
            <b-icon
              icon="window-close"
              type="is-white">
            </b-icon>
          </a>
          <img :src="url" class="imageDetail" alt="">
        </div>
        <div class="columns is-marginless detail_content">
          <div class="column is-paddingless rightVert topVert leftVert">
            <h3 class="has-text-link has-text-weight-bold bottomVert">
              Caractéristiques:</h3>
            <div class="columns is-marginless is-multiline color-icon">
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Adresse
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{adresse}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxNumeriqueComplet.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Matériel
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailReseauxNumeriqueComplet.materiel}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { formatEclaire, formatAdresse, urlPhoto } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxNumeriqueComplet',
  props: ['detailReseauxNumeriqueComplet', 'bg'],
  data() {
    return {
      select: true,
    };
  },
  computed: {
    eclaire() {
      return formatEclaire(this.detailReseauxNumeriqueComplet.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailReseauxNumeriqueComplet);
    },
    url() {
      return urlPhoto(this.detailReseauxNumeriqueComplet.urlPhoto);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxNumeriques/detailReseauxNumeriqueComplet.vue